import React from "react";
import styled from "styled-components";

import PrimaryFilledCircle from "../../assets/img/icons/filled_circle_primary.svg";
import GreyCircle from "../../assets/img/icons/grey-circle.svg";
import { CommonText } from "../../styledComponents/common";

const CircleIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const TabContainer = styled.div`
  display: flex;
  border-radius: ${props => (props.selected ? "32px" : "8px")};
  height: ${props => props.height || "40px"};
  padding: ${props => props.padding || "8px 12px"};
  gap: 8px;
  font-weight: 700;
  font-size: 14px;
  align-items: center;
  cursor: pointer;
  border: 1px solid
    ${props =>
      props.error
        ? props.theme.colors.main.error
        : props.selected
        ? props.theme.colors.main.primary
        : props.theme.colors.border.secondaryLight};
  background-color: ${props =>
    !props.showIcon && props.selected ? "#2266EF" : "white"};
  max-width: fit-content;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props =>
      props.selected
        ? props.theme.colors.main.primary
        : props.theme.colors.main.primary};
    opacity: ${props => (props.selected ? "1" : "0.8")};
    background-color: ${props =>
      !props.showIcon && props.selected ? "#2266EF" : "white"};
  }
`;

const RoundTab = ({
  text,
  selected = false,
  onClick,
  showIcon = true,
  customIcon = null,
  error = false,
  height = "40px",
  padding,
}) => {
  const getIcon = () => {
    if (customIcon) return customIcon;
    return selected ? PrimaryFilledCircle : GreyCircle;
  };

  return (
    <TabContainer
      selected={selected}
      error={error}
      showIcon={showIcon}
      onClick={onClick}
      height={height}
      padding={padding}
    >
      {showIcon && (
        <CircleIcon
          src={getIcon()}
          alt={`${selected ? "Selected" : "Unselected"} Icon`}
        />
      )}
      <CommonText
        color={
          !showIcon && selected ? "#FFFFFF" : selected ? "#2266EF" : undefined
        }
        fontWeight={selected ? "600" : "400"}
        fontSize="14px"
        margin="0"
      >
        {text}
      </CommonText>
    </TabContainer>
  );
};

export default RoundTab;
